import React from "react";
import FinanceRouter from "../router/finance";

const FinanceLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <FinanceRouter />
    </div>
  );
};

export default FinanceLayout;
